const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export type NeighborhoodMetric = {
  id: string;
  label: string;
  value: number | null;
  unit: 'count' | 'usd' | 'percent';
  note?: string;
};

export type NeighborhoodReport = {
  zip: string;
  year: string | null;
  name: string | null;
  source: string;
  sourceUrl: string;
  retrievedAt: string;
  metrics: NeighborhoodMetric[];
  message: string | null;
};

export async function lookupNeighborhood(zip: string): Promise<NeighborhoodReport> {
  const response = await fetch(`${API_BASE}/api/neighborhood?zip=${encodeURIComponent(zip)}`);
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body?.error?.message || 'Neighborhood figures are unavailable right now.');
  }
  return body as NeighborhoodReport;
}

export function formatNeighborhoodValue(metric: NeighborhoodMetric): string {
  if (metric.value == null) return 'Not published';
  if (metric.unit === 'usd') {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
    }).format(metric.value);
  }
  if (metric.unit === 'percent') return `${metric.value}%`;
  return new Intl.NumberFormat('en-US').format(metric.value);
}

export function zipFromAddress(address: string): string | null {
  const match = address.match(/\b(\d{5})(?:-\d{4})?\b/);
  return match ? match[1] : null;
}
